export const getTransform = (x: number, y: number) => `translateX(${x}px) translateY(${y}px) scale(var(--scale))`;
